import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DailySummaryData, TicketSummaryData } from '../../../../../express-tRPC/src/api/lots/types';


export interface TableColumn {
  field: string;
  header: string;
  original_key: string;
}

@Component({
  selector: 'cashier-import-sheet-summary',
  templateUrl: './cashier-import-sheet-summary.component.html',
  styleUrl: './cashier-import-sheet-summary.component.scss'
})
export class CashierImportSheetSummaryComponent implements OnChanges {

  importSummaryInProgress: boolean = false;
  @Input() currentLocation!: string;
  @Input() importFileData!: any;

  @Output() saveDailySummaryData = new EventEmitter<any>();
  @Output() clearSheetSeletion = new EventEmitter<string>();

  fileImportSummaryData: any = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.importFileData);
    this.fileImportSummaryData = [];

    if (this.importFileData?.length) {

      let cashierSummaryRowIndex: number[] = [];
      let cashierTicketSummaryRowIndex: number[] = [];

      for (let rowIndex = 0; rowIndex < this.importFileData.length; rowIndex++) {
        const rowDataObj = this.importFileData[rowIndex];

        // Loop through each column in the row
        Object.keys(rowDataObj).forEach((key: any, columnIndex: number) => {

          // Get the current cell data for the current row
          const cellDataLowerCased: string = rowDataObj[key].toLowerCase();

          if (cellDataLowerCased.includes("date/time: ")) {
            const dateTime: string = cellDataLowerCased.split("date/time: ")[1];
            const date: string = dateTime.split(' ')[0];
            this.fileImportSummaryData.push({ date: date });
          }
          if (cellDataLowerCased == "location") {
            cashierSummaryRowIndex.push(rowIndex);
          }

          if (cellDataLowerCased == "total cash:") {
            cashierSummaryRowIndex.push(rowIndex)
          }

          if (cellDataLowerCased == "start") {
            cashierTicketSummaryRowIndex.push(rowIndex);
          }

          if (cellDataLowerCased == "type") {
            cashierTicketSummaryRowIndex.push(rowIndex)
          }

        });

      }

      //Make sure we have start and end index so we can split "cashier summary" data from sheet
      if (cashierSummaryRowIndex.length == 2) {
        const sheetData = structuredClone(this.importFileData);

        let cashierSummaryData = sheetData.slice(cashierSummaryRowIndex[0], cashierSummaryRowIndex[1]);
        console.log(cashierSummaryData)

        //To get columns lets pick first row
        const columnNames: TableColumn[] = this.getTableColumns(cashierSummaryData[0]);
        const rows: any[] = this.getTableRows(columnNames, cashierSummaryData);

        const getOnlySummaryRow: boolean = true;
        const summaryRow: any[] = this.getTableRows(columnNames, cashierSummaryData, getOnlySummaryRow);


        this.fileImportSummaryData[this.fileImportSummaryData.length - 1]['cashier_summary'] = { columns: columnNames, rows: rows, summary: summaryRow };

      }

      //Make sure we have start and end index so we can split "cashier ticket summary" data from sheet
      if (cashierTicketSummaryRowIndex.length == 2) {
        const sheetData = structuredClone(this.importFileData);

        let cashierTicketSummaryData = sheetData.slice(cashierTicketSummaryRowIndex[0], cashierTicketSummaryRowIndex[1]);
        console.log(cashierTicketSummaryData)

        //To get columns lets pick first row
        const columnNames: TableColumn[] = this.getTableColumns(cashierTicketSummaryData[0]);
        const rows: any[] = this.getTableRows(columnNames, cashierTicketSummaryData);

        const getOnlySummaryRow: boolean = true;
        const summaryRow: any[] = this.getTableRows(columnNames, cashierTicketSummaryData, getOnlySummaryRow);

        this.fileImportSummaryData[this.fileImportSummaryData.length - 1]['cashier_ticket_summary'] = { columns: columnNames, rows: rows, summary: summaryRow };

      }

      console.log(this.fileImportSummaryData);
      // console.log(cashierSummaryRowIndex);

    }

  }

  /**
   *
   * @param tableColumnsRowData object data of tables first row
   * @returns array of columns
   */
  getTableColumns(tableColumnsRowData: any) {
    let columnNames: TableColumn[] = [];
    const columnData = tableColumnsRowData;

    Object.keys(columnData).forEach((columnKey: any) => {
      const column = columnData[columnKey];
      if (columnData[columnKey]) {
        columnNames.push({
          field: column.toLowerCase().replaceAll(" ", "_").replaceAll(".", ""), //This is some unique identifier for each column to connect rows data
          header: column, // Column name
          original_key: columnKey
        });
      }
    });
    return columnNames;
  }

  getTableRows(columnNames: TableColumn[], tableData: any[], getOnlySummaryRow: boolean = false) {
    //Exclude first and last row to get table data
    let tableDataRows = tableData.slice(1, tableData.length - 1);

    if (getOnlySummaryRow) {
      //Extract the last row which will be summary row
      tableDataRows = tableData.slice(tableData.length - 1, tableData.length);
    }

    //Map column array with data. This is the 'Cashier Summary' (top) section of the sheet.
    const worksheetDataRowsUpdatedKeys = tableDataRows.map((rowData: any, rowIndex: number) => {
      let row: any = {};
      Object.keys(rowData).forEach((rowDataKeys: string, index: number) => {
        const matchedColumnIndex = columnNames.findIndex((columnData: any) => columnData.original_key == rowDataKeys);

        if (matchedColumnIndex !== -1) {
          const columnNameBeingProcessesd = columnNames[matchedColumnIndex]['field'];
          row[columnNameBeingProcessesd] = rowData[rowDataKeys];
        }
      });
      return row;
    });

    return worksheetDataRowsUpdatedKeys;

  }

  importSummaryData() {
    let dailySummaryData = structuredClone(this.fileImportSummaryData[0]['cashier_summary']['rows']);
    let ticketSummaryData = structuredClone(this.fileImportSummaryData[0]['cashier_ticket_summary']['rows']);

    const totalTicketsAmount = dailySummaryData.reduce((sum: number, item: any) => sum + parseFloat(item['parking'].replace("$","")), 0);
    const totalTicketsCount = dailySummaryData.reduce((sum: number, item: any) => sum + parseFloat(item['count']), 0);

    /**
     * We want to store only one entry of total daily cashier summary not each record in DRE
     * So we have pushed an object into dailySummaryData
     */
    dailySummaryData = [
      {
        amount: totalTicketsAmount,
        cashier: this.currentLocation,
        shift: 1, //No shift column found in sheet
        tix_collected: totalTicketsCount,
        stations: '' //No stations column found in sheet
      } as DailySummaryData
    ];

    /**
     * Cashier sheet has different column so lets convert it into common format
     *
     **/
    ticketSummaryData = ticketSummaryData.map((ticketSummary: any) => {
      return {
        "shift": 1, //No shift column found in sheet
        "#_of_tickets": ticketSummary['issued'],
        "#_of_voids":  "0",
        "lot_name": "Loc "+this.currentLocation,
        "sequence_#_start_-_end": { sequence_start: ticketSummary['start'], sequence_end: ticketSummary['end'] },
        "station_name": "Default", //No station column found in sheet
      } as TicketSummaryData;
    });

    const importSummaryData = {
      dailySummaryData: dailySummaryData,
      ticketSummaryData: ticketSummaryData,
      date: this.fileImportSummaryData[0]['date']
    };

    this.saveDailySummaryData.emit(importSummaryData);
  }

  clearSummaryData() {
    this.clearSheetSeletion.emit(this.fileImportSummaryData[0]['date']);
  }
}
